import React, { useState } from 'react';
import './App.css';
import { Box } from '@mui/material';
import EarthquakeList from './page/earthquake_list';
import FirstReport from './page/dam/first_report';
import UploadCSVFile from './page/upload_csvfile';
import PrimaryInspection from './page/dam/primary_inspection';
import InitialTask from './page/dam/initial_task'
import SecondaryInspection from './page/dam/secondary_inspection'
import CalloutRegistration from './page/callout_registration';
import CalloutComplete from './page/callout_complete';
import MyPage from './page/my_page';
import Login from './page/login';
import Footer from './components/footer';
import Top from './page/top';
import MstPartnerList from './page/mst_partner_list';
import EarthquakeRegister from './page/earthquake_register';
import MstPartnerCompanyList from './page/mst_partner_company_list';
import EarthquakeDetail from './page/earthquake_detail';
import Callout from './page/callout';
import MstRecipientList from './page/mst_recipient_list.jsx';
import MstDepartmentList from './page/mst_department_list.jsx';
import MstUserList from './page/mst_user_list.jsx';
import MstWorkList from './page/mst_work_list.jsx';
import PowerPlantWorkCheck from './page/powerplant/work_check.jsx';
import FirstReportPowerPlantPatrol from './page/first_report_powerplant_patrol';
import MstSuiroExtractRequiredList from './page/mst_suiro_extract_required_list';
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import Header from './components/header';
import SlideMenu from './components/slide_menu';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { ROLE_UUID } from './const/config';

// 認証が必要なルート用のラッパーコンポーネント
const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();
  const location = useLocation();

  // 認証状態確認中はローディングを表示
  if (loading) {
    return <div>Loading...</div>;
  }

  // 認証されていない場合はログインページにリダイレクト
  if (!isAuthenticated) {
    return <Navigate
      to="/login"
      state={{ from: location.pathname + location.search }}
      replace
    />;
  }
  return children;
};

// 管理者権限が必要なルート用のラッパー
const AdminRoute = ({ children }) => {
  const { currentUser, loading } = useAuth();

  if (loading) {
    return <div>Loading...</div>;
  }

  // 管理者権限がない場合はTopページへリダイレクト
  if (!currentUser || currentUser.role_id !== ROLE_UUID.ADMIN) {
    return <Navigate to="/top" replace />;
  }

  return children;
};

const HEADER_HEIGHT = '64px';

const BasePages = ({ children }) => {
  const [open, setOpen] = useState(false);
  return (
    <>
      <Header open={open} setOpen={setOpen} />
      <SlideMenu open={open} setOpen={setOpen} />
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          // 固定ヘッダー（AppBar）の高さ分、コンテンツの上部に余白を開ける
          paddingTop: HEADER_HEIGHT,
          minHeight: '100vh',
          // 必要であれば、temporary Drawer のための margin/transition は不要なため削除
          marginLeft: 0,
          transition: 'none',
        }}
      >
        {children}
      </Box>
      <Footer />
    </>
  );
};

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          {/* ログインページ - 認証不要 */}
          <Route path="/login" element={<Login />} />

          {/* 認証が必要なルート */}
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <BasePages><Top /></BasePages>
              </ProtectedRoute>
            }
          />
          <Route
            path="/earthquake_register"
            element={
              <ProtectedRoute>
                <BasePages><EarthquakeRegister /></BasePages>
              </ProtectedRoute>
            }
          />
          <Route
            path="/earthquake_list"
            element={
              <ProtectedRoute>
                <BasePages><EarthquakeList /></BasePages>
              </ProtectedRoute>
            }
          />
          <Route
            path="/first_report/:uuid"
            element={
              <ProtectedRoute>
                <BasePages><FirstReport /></BasePages>
              </ProtectedRoute>
            }
          />
          <Route
            path="/primary_inspection/:uuid"
            element={
              <ProtectedRoute>
                <BasePages><PrimaryInspection /></BasePages>
              </ProtectedRoute>
            }
          />
          <Route
            path="/secondary_inspection/:uuid"
            element={
              <ProtectedRoute>
                <BasePages><SecondaryInspection /></BasePages>
              </ProtectedRoute>
            }
          />
          <Route
            path="/upload_csvfile/:uuid"
            element={
              <BasePages><UploadCSVFile /></BasePages>

            }
          />
          <Route
            path="/initial_task/:uuid"
            element={
              <ProtectedRoute>
                <BasePages><InitialTask /></BasePages>
              </ProtectedRoute>
            }
          />
          <Route
            path="/top"
            element={
              <ProtectedRoute>
                <BasePages><Top /></BasePages>
              </ProtectedRoute>
            }
          />
          <Route
            path="/callout_registration/:uuid"
            element={
              <ProtectedRoute>
                <BasePages><CalloutRegistration /></BasePages>
              </ProtectedRoute>
            }
          />
          <Route
            path="/callout_complete/:uuid"
            element={
              <ProtectedRoute>
                <BasePages><CalloutComplete /></BasePages>
              </ProtectedRoute>
            }
          />
          <Route
            path="/my_page"
            element={
              <ProtectedRoute>
                <BasePages><MyPage /></BasePages>
              </ProtectedRoute>
            }
          />
          <Route
            path="/mst_partner_company_list"
            element={
              <ProtectedRoute>
                <AdminRoute>
                  <BasePages><MstPartnerCompanyList /></BasePages>
                </AdminRoute>
              </ProtectedRoute>
            }
          />
          <Route
            path="/mst_partner_list"
            element={
              <ProtectedRoute>
                <AdminRoute>
                  <BasePages><MstPartnerList /></BasePages>
                </AdminRoute>
              </ProtectedRoute>
            }
          />
          <Route
            path="/earthquake_detail/:uuid"
            element={
              <ProtectedRoute>
                <BasePages><EarthquakeDetail /></BasePages>
              </ProtectedRoute>
            }
          />
          <Route
            path="/mst_recipient_list"
            element={
              <ProtectedRoute>
                <AdminRoute>
                  <BasePages><MstRecipientList /></BasePages>
                </AdminRoute>
              </ProtectedRoute>
            }
          />
          <Route
            path="/callout/:uuid"
            element={
              <ProtectedRoute>
                <BasePages><Callout /></BasePages>
              </ProtectedRoute>
            }
          />
          <Route
            path="/mst_department_list"
            element={
              <ProtectedRoute>
                <AdminRoute>
                  <BasePages><MstDepartmentList /></BasePages>
                </AdminRoute>
              </ProtectedRoute>
            }
          />
          <Route
            path="/mst_user_list"
            element={
              <ProtectedRoute>
                <AdminRoute>
                  <BasePages><MstUserList /></BasePages>
                </AdminRoute>
              </ProtectedRoute>
            }
          />
          <Route
            path="/mst_work_list"
            element={
              <ProtectedRoute>
                <AdminRoute>
                  <BasePages><MstWorkList /></BasePages>
                </AdminRoute>
              </ProtectedRoute>
            }
          />
          <Route
            path="/powerplant_work_check/:uuid"
            element={
              <ProtectedRoute>
                <BasePages><PowerPlantWorkCheck /></BasePages>
              </ProtectedRoute>
            }
          />
          <Route
            path="/first_report_powerplant_patrol/:uuid"
            element={
              <ProtectedRoute>
                <BasePages><FirstReportPowerPlantPatrol /></BasePages>
              </ProtectedRoute>
            }
          />
          <Route
            path="/mst_suiro_extract_required_list"
            element={
              <ProtectedRoute>
                <AdminRoute>
                  <BasePages><MstSuiroExtractRequiredList /></BasePages>
                </AdminRoute>
              </ProtectedRoute>
            }
          />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;